import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import FiltrosPlaning from '../../components/planing/FiltrosPlaning'
import {elegirDiasPlaning, abrirModalPlaning, fetchFiltrarPlaning, cargarVerracosPlanificados, abrirModalExportarImprimirPlaning, abrirDuplicarPlaning, seleccionarTodosPlanningPrincipal, deSeleccionarTodosPlanningPrincipal, anadirSeleccionPlaningPrincipal, eliminarSeleccionPlaningPrincipal, imprimirZebraVerracos} from '../../actions/planing/planing'
import {comboRaza, comboLineaGenetica, comboUbicacionPadre, comboNombreGrupoVerraco, comboOperario, comboCliente, comboIndex, comboNivelGenetico} from '../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
    ...state.planing,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    formSimpleTable: state.form.simpleTable,
    auth: state.auth,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      elegirDiasPlaning,
      abrirModalPlaning,
      comboRaza,
      comboLineaGenetica,
      comboUbicacionPadre,
      comboNombreGrupoVerraco,
      fetchFiltrarPlaning,
      cargarVerracosPlanificados,
      comboOperario,
      comboCliente,
      abrirModalExportarImprimirPlaning,
      comboIndex,
      imprimirZebraVerracos,
      abrirDuplicarPlaning,
      seleccionarTodosPlanningPrincipal,
      deSeleccionarTodosPlanningPrincipal,
      anadirSeleccionPlaningPrincipal,
      eliminarSeleccionPlaningPrincipal,
      comboNivelGenetico
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FiltrosPlaning))